import * as React from 'react';
import styled from 'styled-components';

const Section = styled.section`
	font-weight: 600;
	font-family: ${(props) => props.theme.headingFont};

	&#problemSolution {
		align-items: flex-start;
	}

	@media (${(props) => props.theme.mediumUp}) {
		& article.problem.col-md-6 {
			padding-right: 1.2em;
		}

		& article.solution.col-md-6 {
			padding-left: 1.2em;
		}
	}


	& h3 {
		text-transform: uppercase;
		font-size: 20px;
		margin-bottom: 0.5em;

		@media (${(props) => props.theme.mediumUp}) {
			font-size: 26px;
		}
	}

	& p {
		font-size: 21px;
		line-height: 1.48;
		margin-bottom: 2em;

		@media (${(props) => props.theme.mediumUp}) {
			font-size: 21px;
			line-height: 1.4;
		}
	}
`;

const ProblemSolution = (props: any) => (
	<div className='centeredWrapper'>
		<Section className='problem-solution row row-flush centered' id='problemSolution'>
			<article className='problem col-12 col-md-6' style={props.problemExtraStyle}>
				<h3>The Problem</h3>
				<p>{props.problem}</p>
			</article>
			<article className='solution col-12 col-md-6' style={props.solutionExtraStyle}>
				<h3>The Solution</h3>
				<p>{props.solution}</p>
			</article>
		</Section>
	</div>
);

export default ProblemSolution;
